import * as React from "react";
import { Drawer, IconButton, Divider, Theme, createStyles, List } from "@material-ui/core";
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
import { withStyles, WithStyles } from "@material-ui/core/styles";
import LogoutListItemButton from "../../../common/Components/LogoutListItemButton";
import { NavItem } from "../../navItems";
import { withRouter, RouteComponentProps } from "react-router";
import NavItemListItemButton from "./NavItemListItemButton";
import { logout } from "../../actions/authActions";
import { ThunkDispatch } from "redux-thunk";
import { StoreState } from "../../store/storeState";
import { AnyAction } from "redux";
import { connect } from "react-redux";
import { cssVars } from "src/globalCssVars";

interface AppDrawerDispatchProps {
  logout: () => void;
}

interface AppDrawerProps extends AppDrawerDispatchProps, WithStyles<typeof styles>, RouteComponentProps<any> {
  open: boolean;
  navItems: NavItem[];
  closeDrawer: () => void;
}

class AppDrawer extends React.PureComponent<AppDrawerProps> {
  onLogout = () => {
    this.handleDrawerClose();
    this.props.history.push("/");
    this.props.logout();
  };

  handleDrawerClose = () => {
    this.props.closeDrawer();
  };

  navigate = (path: string) => {
    this.handleDrawerClose();
    this.props.history.push(path);
  };

  render() {
    const { open, classes, navItems } = this.props;
    return (
      <Drawer classes={{ paper: classes.drawerPaper }} variant="persistent" anchor={"left"} open={open}>
        <div className={classes.drawerHeader}>
          <IconButton onClick={this.handleDrawerClose}>{<ChevronLeftIcon />}</IconButton>
        </div>
        <Divider />
        <div className={classes.drawerContentContainer}>
          <div className={classes.drawerContent}>
            <List style={{ padding: 0 }}>
              {navItems.map(
                n => (n.hideInMenu ? "" : <NavItemListItemButton key={n.path} navigate={this.navigate} navItem={n} />)
              )}
              <Divider />
              <LogoutListItemButton onLogout={this.onLogout} />
            </List>
          </div>
        </div>
      </Drawer>
    );
  }
}

const styles = (theme: Theme) =>
  createStyles({
    drawerPaper: {
      width: `${cssVars.drawerWidth}rem`
    },
    drawerContent: {
      flexGrow: 1
    },
    drawerContentContainer: {
      height: `calc(100vh - ${theme.spacing.unit * 8}rem)`,
      display: "flex",
      flexDirection: "column"
    },
    drawerHeader: {
      display: "flex",
      alignItems: "center",
      justifyContent: "flex-end",
      padding: "0 0.5rem",
      height: theme.spacing.unit * 8 + "rem"
    }
  });

const mapDispatchToProps = (dispatch: ThunkDispatch<StoreState, void, AnyAction>): AppDrawerDispatchProps => {
  return {
    logout: () => dispatch(logout)
  };
};

export default connect(
  null,
  mapDispatchToProps
)(withRouter(withStyles(styles)(AppDrawer)));
